import axios from "axios";

export default {
  getVariants: async questionId => {
    const response = await axios.get('/api/questions/' + questionId + '/variants');
    return response.data;
  },
};
